import React, { Component } from "react";
import { debounce } from "lodash";
import api from "services/api";
import { Link } from "react-router-dom";
import DatePicker, { registerLocale } from "react-datepicker";
import swal from "sweetalert";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as MultiplierActions,
  Selectors as MultiplierSelectors,
} from "store/ducks/multipliers";

import { Access, Environment } from "common";
import { Form, Icon, Loading } from "components";
import { ImportProducts } from "./components";

import ptBr from 'date-fns/locale/pt-BR';
registerLocale('pt-BR', ptBr);

const MAX_LM_IMPORT_LENGTH = Environment.getEnvNumber("REACT_APP_MAX_LM_IMPORT_LENGTH") ?? 1000;

class CustomForm extends Component {
  static defaultProps = {
    edit: false,
  };

  state = {
    data: this.props.data,
    coupons_limit: true,
    campaigns: [],
    categories: [],
    stores: [],
    channels: [],
    productTypes: [],
    sections: [],
    subSections: [],
    products: [],
    passions: [],
    discounts: [],
    collapses: {
      interests: false,
      products: false,
    },
    addStoreProducts: false,
    removeStoreProducts: false,
    groups: [],
    subGroups: [],
  };

  constructor(props) {
    super(props);

    const {
      getMultiplierChannelsRequest,
      getMultiplierRegionsRequest,
      getMultiplierStoresRequest,
      getMultiplierProductTypesRequest,
      getMultiplierSectionsRequest,
      getMultiplierSubSectionsRequest,
      getMultiplierProductsRequest,
      getMultiplierPassionsRequest,
      getMultiplierPlansRequest,
    } = props;

    this.handleSearchChannel = debounce(getMultiplierChannelsRequest, 300);
    this.handleSearchRegion = debounce(getMultiplierRegionsRequest, 300);
    this.handleSearchStore = debounce(getMultiplierStoresRequest, 300);
    this.handleSearchProductType = debounce(
      getMultiplierProductTypesRequest,
      300
    );
    this.handleSearchSection = debounce(getMultiplierSectionsRequest, 300);
    this.handleSearchSubSection = debounce(
      getMultiplierSubSectionsRequest,
      300
    );
    this.handleSearchProduct = debounce(getMultiplierProductsRequest, 300);
    this.handleSearchPassion = debounce(getMultiplierPassionsRequest, 300);
    this.handleSearchPlan = debounce(getMultiplierPlansRequest, 300);
  }

  componentDidMount() {
    const {
      getMultiplierCategoriesRequest,
      getMultiplierChannelsRequest,
      getMultiplierRegionsRequest,
      getMultiplierProductTypesRequest,
      getMultiplierSectionsRequest,
      getMultiplierProductsRequest,
      getMultiplierPassionsRequest,
      getMultiplierStoresRequest,
      getMultiplierPlansRequest,
    } = this.props;

    getMultiplierCategoriesRequest();
    getMultiplierChannelsRequest();
    getMultiplierRegionsRequest();
    getMultiplierProductTypesRequest();
    getMultiplierSectionsRequest();
    getMultiplierProductsRequest();
    getMultiplierPassionsRequest();
    getMultiplierStoresRequest();
    getMultiplierPlansRequest();
    this.loadDiscounts();
  }

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { loading, onChange } = this.props;

    if (oldProps.loading && !loading && oldProps.data !== this.props.data) {
      const {
        store_sub_sections,
        store_groups,
        store_sub_groups,
        store_subgroups,
      } = this.props.data.extra_data;

      const storeSubGroups =  store_sub_groups ? store_sub_groups : store_subgroups;

      const groups = store_sub_sections ? [...store_groups] : [];
      const subGroups = store_groups ? [...storeSubGroups] : [];

      this.setState({
        coupons_limit: this.props.data.activation_limit === 0,
        data: {
          ...this.props.data,
        },
        groups,
        subGroups,
      });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleChangeInput = (e) => {
    const { data } = this.state;
    const { name, value } = e.target;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleChangeSelect = (name, option) => {
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: option, title: option.label } });
  };

  handleChangePeriod = (e) => {
    const { data } = this.state;
    const { value } = e.target;

    this.setState({
      data: { ...data, activation_period: value === "true" ? true : false },
    });
  };

  handleChangeCoupon = (e) => {
    const { value } = e.target;

    this.setState({ coupons_limit: value === "true" ? true : false });
  };

  handleToggleExtra = (name) => {
    const { data } = this.state;

    if (name === "add_mdh") {
      this.setState({
        data: {
          ...data,
          extra_data: {
            ...data.extra_data,
            [name]: !data.extra_data[name],
            remove_mdh: false,
          },
        },
      });
    } else if (name === "remove_mdh") {
      this.setState({
        data: {
          ...data,
          extra_data: {
            ...data.extra_data,
            [name]: !data.extra_data[name],
            add_mdh: false,
          },
        },
      });
    } else {
      this.setState({
        data: {
          ...data,
          extra_data: { ...data.extra_data, [name]: !data.extra_data[name] },
        },
      });
    }
  };

  handleChangeDate = (name, value) => {
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleSelectCategory = (option) => {
    const { data } = this.state;

    this.setState({ data: { ...data, voucher_category_id: option } });
  };

  handleFindTypes = (value) => {
    this.handleSearchTypes(value, true);
  };

  handleSelectType = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        experience_voucher_configuration_id: value,
      },
    });
  };

  handleFindChannel = (value) => {
    this.handleSearchChannel(value);
  };

  handleSelectChannels = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        store_channels: value,
        store_channels_all: !value.length,
      },
    });
  };

  handleFindPlan = (value) => {
    this.handleSearchPlan(value);
  };

  handleSelectPlans = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          experience_plan_ids: value,
        },
      },
    });
  };

  handleFindStore = (value) => {
    const { data } = this.state;

    if (!value) return;

    const regionsId =
      data.extra_data.store_region && data.extra_data.store_region.value
        ? data.extra_data.store_region.value
        : null;

    this.handleSearchStore(value, regionsId);
  };

  handleSelectStores = (value) => {
    const { data } = this.state;
    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          store_places: value,
          store_places_all: false,
        },
      },
    });
  };

  handleFindCampaign = (value) => {
    this.handleSearchCampaign(value);
  };

  handleSelectCampaign = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        experience_commercial_campaigns_id: value,
      },
    });
  };

  handleFindRegion = (value) => {
    this.handleSearchRegion(value);
  };

  handleSelectRegions = (value) => {
    const { data } = this.state;

    if (value !== null) {
      this.handleSearchStore("", value.value);
    }

    this.setState({
      data: {
        ...data,
        store_region: value,
        extra_data: {
          ...data.extra_data,
          store_places: [],
          store_places_all:
            value !== null ? false : data.extra_data.store_places_all,
        },
      },
    });
  };

  handleFindProductType = (value) => {
    this.handleSearchProductType(value);
  };

  handleSelectProductTypes = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          store_product_types: value,
          store_product_types_all: false,
        },
      },
    });
  };

  handleFindSection = (value) => {
    this.handleSearchSection(value);
  };

  handleSelectSections = async (value, a, b) => {
    const { data } = this.state;

    await this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          store_sections: value,
          store_sections_all: false,
        },
      },
    });
    this.handleFindSubSection("");
  };

  handleFindSubSection = (value) => {
    const { data } = this.state;

    !!data.extra_data.store_sections.length
      ? this.handleSearchSubSection(
        value,
        data.extra_data.store_sections[0].value
      )
      : this.handleSearchSubSection(value);
  };

  handleSelectSubSections = (value) => {
    const { data } = this.state;

    const groups = value
      .map((subSection) => subSection.subSection.attributes.groups)
      .flat()
      .map((group) => ({
        value: group.id,
        label: group.name,
        external_id: group.external_id,
        group,
      }));

    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          store_sub_sections: value,
          store_sub_sections_all: false,
          store_groups: data.extra_data.store_groups.filter(
            (group) => !!groups.find((g) => g.group === group.value)
          ),
        },
      },
      groups,
    });
  };

  handleSelectGroups = (value) => {
    const { data } = this.state;

    const subGroups = value
      .map((group) => group.group.sub_groups)
      .flat()
      .map((subGroup) => ({
        value: subGroup.id,
        label: subGroup.name,
        external_id: subGroup.external_id,
      }));

    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          store_groups: value,
          store_sub_groups: data.extra_data.store_sub_groups.filter(
            (subGroup) => !!subGroups.find((sg) => sg.value === subGroup.value)
          ),
        },
      },
      subGroups,
    });
  };

  handleSelectSubGroups = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: { ...data.extra_data, store_sub_groups: value },
      },
    });
  };

  handleFindProduct = (value) => {
    this.handleSearchProduct(value);
  };

  handleSelectAddProduct = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: { ...data.extra_data, add_store_products: value },
      },
    });
  };

  handleSelectRemoveProduct = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: { ...data.extra_data, remove_store_products: value },
      },
    });
  };

  handleFindPassion = (value) => {
    this.handleSearchPassion(value);
  };

  handleSelectPassions = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          classification_passions: value,
          classification_passions_all: false,
        },
      },
    });
  };

  loadDiscounts = async () => {
    const response = await api.get(
      `settings/v2/confs/search?name=LMB_BENEFITS_RANGE_DISCOUNT`
    );
    const { data } = response.data;
    const { value } = data.attributes;

    this.setState({
      discounts: value
        .split(",")
        .map((discount) => ({ value: discount, label: `${discount}%` })),
    });
  };

  handleToggle = (name) => {
    const { data } = this.state;

    if (name === "app_only" && !data["app_only"]) {
      this.setState({
        data: { ...data, store_channels_all: true, [name]: !data[name] },
      });
    } else {
      this.setState({ data: { ...data, [name]: !data[name] } });
    }
  };

  handleToggleCollapses = (name, e) => {
    e.preventDefault();
    const { collapses } = this.state;

    this.setState({ collapses: { ...collapses, [name]: !collapses[name] } });
  };

  handleApprove = async () => {
    const { data } = this.state;
    const { approveMultiplierRequest, filters } = this.props;

    const approve = await swal({
      title: "Aprovar Campanha",
      text: "Deseja mesmo aprovar?",
      buttons: {
        cancel: "Cancelar",

        confirm: {
          text: "Sim, aprovar",
        },
      },
    });

    !!approve && approveMultiplierRequest(data.id, { filters });
  };

  handleRepprove = async () => {
    const { data } = this.state;
    const { repproveMultiplierRequest, filters } = this.props;

    const obs = await swal({
      title: "Reprovar Campanha",
      text: "",
      content: {
        element: "input",
        attributes: {
          value: "",
          placeholder: "Descreva o motivo",
        },
      },
      buttons: {
        cancel: "Cancelar",

        confirm: {
          text: "Reprovar",
        },
      },
    });

    if (obs === "") {
      await swal(
        "Você precisa adicionar uma observação para reprovar a campanha",
        "",
        "error"
      );
      this.handleRepprove();
    } else if (obs !== null) {
      repproveMultiplierRequest(data.id, { voucher: { obs }, filters });
    }
  };

  handleToggleAddStoreProduct = () => {
    const { addStoreProducts } = this.state;

    this.setState({ addStoreProducts: !addStoreProducts });
  };

  handleToggleRemoveStoreProduct = () => {
    const { removeStoreProducts } = this.state;

    this.setState({ removeStoreProducts: !removeStoreProducts });
  };

  handleImportProducts = async (grid, name) => {
    const { data } = this.state;
    try {
      this.setState({ importing: true });
      const skus = grid
        .map((sku) => sku[0].value)
        .filter((sku) => sku !== null && sku !== "")
        .join(`&skus[]=`);

      const response = await api.get(
        `store/v2/products?per=${MAX_LM_IMPORT_LENGTH}&skus[]=${skus}`
      );
      const products = response.data.data;

      let newList = [
        ...data.extra_data[name],
        ...products
          .filter(
            (product) =>
              !data.extra_data[name]
                .map((item) => item.value)
                .includes(product.id)
          )
          .map((product) => {
            return {
              sku: product.attributes.sku,
              value: product.id,
              label: product.attributes.sku,
            };
          }),
      ];

      if (newList.length > MAX_LM_IMPORT_LENGTH) {
        newList = newList.slice(0, MAX_LM_IMPORT_LENGTH);

        swal(
          `Máximo ${MAX_LM_IMPORT_LENGTH} produtos`,
          `O limite máximo de produtos é ${MAX_LM_IMPORT_LENGTH}, todos os produtos que excederam o limite não foram importados.`,
          "info"
        );
      }

      this.setState({
        data: {
          ...data,
          extra_data: {
            ...data.extra_data,
            [name]: newList,
          },
        },
      });
    } catch (error) {
      this.setState({
        data: {
          ...data,
          extra_data: {
            ...data.extra_data,
            [name]: [],
          },
        },
      });
    } finally {
      this.setState({ importing: false });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { onSave } = this.props;

    onSave();
  };

  handleChangeCPFs = (value) => {
    const { data } = this.state;

    this.setState({ data: { ...data, cpf_list: value } });
  };

  handleToggleAllProducts = async (name) => {
    const { data } = this.state;

    if (!data.extra_data.all_products) {
      const handleAllProducts = await swal({
        title: "Cadastrar todos os produtos",
        text: "Deseja cadastrar todos os produtos?",
        buttons: {
          cancel: "Não",

          confirm: {
            text: "Sim",
          },
        },
      });

      if (handleAllProducts) {
        this.setState({
          data: {
            ...data,
            extra_data: {
              ...data.extra_data,
              store_product_types: Access.lockedProductType()
                ? [Access.lockedProductType(true)]
                : [],
              store_product_types_all: Access.lockedProductType()
                ? false
                : false,
              store_sections: [],
              store_sections_all: false,
              store_sub_sections: Access.lockedSection()
                ? [Access.lockedSection(true)]
                : [],
              store_sub_sections_all: Access.lockedSection() ? false : false,
              store_groups: [],
              store_sub_groups: [],
              remove_mdh: false,
              add_mdh: false,
              add_store_products: [],
              remove_store_products: [],
              [name]: !data.extra_data[name],
            },
          },
        });
      }
    } else {
      this.setState({
        data: {
          ...data,
          extra_data: {
            ...data.extra_data,
            [name]: !data.extra_data[name],
          },
        },
      });
    }
  };

  render() {
    const {
      data,
      collapses,
      addStoreProducts,
      removeStoreProducts,
      groups,
      subGroups,
      importing,
    } = this.state;
    const {
      errors,
      saving,
      regions,
      stores,
      channels,
      productTypes,
      sections,
      subSections,
      products,
      plans,
      edit,
      approve,
      repprove,
      filters,
    } = this.props;

    return (
      <Form className="page-form" onSubmit={this.handleSubmit}>
        <h3 className="form-title">Detalhes do Benefício</h3>

        {data.voucher_status === "reproved" && (
          <div className="alert alert-warning">
            <h4>Reprovado</h4>

            {data.voucher_status_obs}
          </div>
        )}

        <Form.Field>
          <Form.Label>Descrição</Form.Label>
          <Form.Input
            name="description"
            placeholder="Descrição da campanha de pontos"
            value={data.description}
            onChange={this.handleChangeInput}
            errors={errors.description}
          />

          <small className="characters">
            Descrição contém {data.description.length} caracteres
          </small>
        </Form.Field>

        <Form.Field>
          <Form.Label>Multiplicador de pontos (ex: 1.75)</Form.Label>
          <Form.Input
            name="multiplier"
            placeholder="Multiplicador de pontos"
            value={data.multiplier}
            onChange={this.handleChangeInput}
            errors={errors.multiplier}
          />
        </Form.Field>

        <Form.Field className="datepicker-field" errors={errors.start_at}>
          <Form.Label>Início</Form.Label>
          <DatePicker
            locale="pt-BR"
            selected={data.start_at}
            onChange={(value) => this.handleChangeDate("start_at", value)}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={1}
            dateFormat="dd/MM/yyyy HH:mm"
            timeCaption="time"
            className={errors.start_at && "parsley-error"}
          />
          <div className="icon-input">
            <span className="glyph glyph-calendar" />
          </div>
        </Form.Field>

        <Form.Field className="datepicker-field" errors={errors.end_at}>
          <Form.Label>Fim</Form.Label>
          <DatePicker
            locale="pt-BR"
            selected={data.end_at}
            onChange={(value) => this.handleChangeDate("end_at", value)}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={1}
            dateFormat="dd/MM/yyyy HH:mm"
            timeCaption="time"
            className={errors.end_at && "parsley-error"}
          />
          <div className="icon-input">
            <span className="glyph glyph-calendar" />
          </div>
        </Form.Field>

        <Form.Field className="field-select">
          <Form.Label>Planos</Form.Label>
          <Form.Select
            isMulti
            placeholder="Planos"
            noOptionsMessage={() => "Procurar planos"}
            options={plans.data}
            onInputChange={this.handleFindPlan}
            onChange={this.handleSelectPlans}
            value={data.extra_data.experience_plan_ids}
          />
        </Form.Field>

        <Form.Field className="field-select">
          <Form.Label>Canais</Form.Label>
          <Form.Select
            isMulti
            placeholder="Canais"
            noOptionsMessage={() => "Procurar canais"}
            options={channels.data}
            onInputChange={this.handleFindChannel}
            onChange={this.handleSelectChannels}
            value={data.store_channels}
            isDisabled={!!Access.lockedChannel() || data.store_channels_all}
          />
        </Form.Field>

        <Form.Field className="checkbox-field">
          <Form.Label>Todos os canais</Form.Label>
          <Form.Checkbox
            checked={data.store_channels_all}
            onChange={() => this.handleToggle("store_channels_all")}
            disabled={data.app_only}
          />
        </Form.Field>

        <Form.Field className="field-select">
          <Form.Label>Região</Form.Label>
          <Form.Select
            placeholder="Região"
            noOptionsMessage={() => "Procurar região"}
            options={regions.data}
            onInputChange={this.handleFindRegion}
            onChange={this.handleSelectRegions}
            value={data.store_region}
            isDisabled={!!Access.lockedStore()}
            isClearable
          />
        </Form.Field>

        <h1>{Access.lockedStore()}</h1>

        <Form.Field className="field-select">
          <Form.Label>Lojas</Form.Label>
          <Form.Select
            isMulti
            placeholder="Lojas"
            noOptionsMessage={() => "Procurar lojas"}
            options={stores.data}
            onInputChange={this.handleFindStore}
            onChange={this.handleSelectStores}
            value={data.extra_data.store_places}
            isDisabled={!!Access.lockedStore()}
          />
        </Form.Field>

        {!Access.lockedStore() && (
          <Form.Field className="checkbox-field">
            <Form.Label>Todas as lojas</Form.Label>
            <Form.Checkbox
              name="store_places_all"
              checked={data.extra_data.store_places_all}
              onChange={() => this.handleToggleExtra("store_places_all")}
              disabled={data.extra_data.store_region !== null}
            />
          </Form.Field>
        )}

        <div className="form-section">
          <Form.Field className="checkbox-field margin-top-30">
            <Form.Label>Vale para todos os produtos</Form.Label>
            <Form.Checkbox
              name="all_products"
              checked={data.extra_data.all_products}
              onChange={() => this.handleToggleAllProducts("all_products")}
            />
          </Form.Field>
        </div>

        <div className="form-section">
          <h4 className="form-section-title">
            Seções/Produtos
            <button
              className="form-section-toggler"
              onClick={(e) => this.handleToggleCollapses("products", e)}
            >
              <Icon
                name={collapses.products ? "caret-up" : "caret-down"}
                prefix="fa"
              />
            </button>
          </h4>

          <div
            className={`form-section-collapse ${
              collapses.products ? "open" : ""
              }`}
          >
            <Form.Field className="field-select">
              <Form.Label>Tipos de produtos</Form.Label>
              <Form.Select
                isMulti
                placeholder="Tipos de produtos"
                noOptionsMessage={() => "Procurar tipos de produtos"}
                options={productTypes.data}
                onInputChange={this.handleFindProductType}
                onChange={this.handleSelectProductTypes}
                value={data.extra_data.store_product_types}
                isDisabled={
                  !!Access.lockedProductType() || data.extra_data.all_products
                }
              />
            </Form.Field>

            {!Access.lockedProductType() && (
              <Form.Field className="checkbox-field">
                <Form.Label>Todos os tipos de produto</Form.Label>
                <Form.Checkbox
                  disabled={data.extra_data.all_products}
                  checked={data.extra_data.store_product_types_all}
                  onChange={() =>
                    this.handleToggleExtra("store_product_types_all")
                  }
                />
              </Form.Field>
            )}

            <Form.Field className="field-select">
              <Form.Label>Seções</Form.Label>
              <Form.Select
                isMulti
                placeholder="Seções"
                noOptionsMessage={() => "Procurar seções"}
                options={sections.data}
                onInputChange={this.handleFindSection}
                onChange={this.handleSelectSections}
                value={data.extra_data.store_sections}
                isDisabled={
                  !!Access.lockedSection() || data.extra_data.all_products
                }
              />
            </Form.Field>

            {!Access.lockedSection() && (
              <Form.Field className="checkbox-field">
                <Form.Label>Todas as seções</Form.Label>
                <Form.Checkbox
                  disabled={data.extra_data.all_products}
                  checked={data.extra_data.store_sections_all}
                  onChange={() => this.handleToggleExtra("store_sections_all")}
                />
              </Form.Field>
            )}

            <Form.Field className="field-select">
              <Form.Label>Subseções</Form.Label>
              <Form.Select
                isMulti
                isDisabled={data.extra_data.all_products}
                placeholder="Subseções"
                noOptionsMessage={() => "Procurar subseções"}
                options={subSections.data}
                onInputChange={this.handleFindSubSection}
                onChange={this.handleSelectSubSections}
                value={data.extra_data.store_sub_sections}
              />
            </Form.Field>

            <Form.Field className="checkbox-field">
              <Form.Label>Todas as sub seções</Form.Label>
              <Form.Checkbox
                disabled={data.extra_data.all_products}
                checked={data.extra_data.store_sub_sections_all}
                onChange={() =>
                  this.handleToggleExtra("store_sub_sections_all")
                }
              />
            </Form.Field>

            {!!groups.length && (
              <Form.Field className="field-select">
                <Form.Label>Grupos</Form.Label>
                <Form.Select
                  isMulti
                  isDisabled={data.extra_data.all_products}
                  placeholder="Grupos"
                  noOptionsMessage={() => "Procurar grupos"}
                  options={groups}
                  onChange={this.handleSelectGroups}
                  value={data.extra_data.store_groups}
                />
              </Form.Field>
            )}

            {!!groups.length && !!subGroups.length && (
              <Form.Field className="field-select">
                <Form.Label>Sub Grupos</Form.Label>
                <Form.Select
                  isMulti
                  isDisabled={data.extra_data.all_products}
                  placeholder="Sub Grupos"
                  noOptionsMessage={() => "Procurar sub grupos"}
                  options={subGroups}
                  onChange={this.handleSelectSubGroups}
                  value={data.extra_data.store_sub_groups}
                />
              </Form.Field>
            )}

            <Form.Field className="checkbox-field">
              <Form.Label>Remover produtos MDH</Form.Label>
              <Form.Checkbox
                disabled={data.extra_data.all_products}
                checked={data.extra_data.remove_mdh}
                onChange={() => this.handleToggleExtra("remove_mdh")}
              />
            </Form.Field>

            <Form.Field className="checkbox-field">
              <Form.Label>Somente Produtos MDH</Form.Label>
              <Form.Checkbox
                disabled={data.extra_data.all_products}
                checked={data.extra_data.add_mdh}
                onChange={() => this.handleToggleExtra("add_mdh")}
              />
            </Form.Field>

            <Form.Field className="field-select">
              <Form.Label>Incluir itens na campanha (LMs)</Form.Label>
              <div className="row">
                <div className="col-md-10">
                  <Form.Select
                    isMulti
                    isDisabled={data.extra_data.all_products}
                    placeholder="Incluir itens na campanha (LMs)"
                    noOptionsMessage={() => "Procurar itens"}
                    options={products.data}
                    onInputChange={this.handleFindProduct}
                    onChange={this.handleSelectAddProduct}
                    value={data.extra_data.add_store_products}
                    className="limited-height"
                  />

                  <small className="characters">
                    {data.extra_data.add_store_products.length}/{MAX_LM_IMPORT_LENGTH} produtos
                  </small>
                </div>

                <div className="col-md-2">
                  <button
                    type="button"
                    className="btn-import-products"
                    onClick={this.handleToggleAddStoreProduct}
                    disabled={data.extra_data.all_products}
                  >
                    Importar
                  </button>
                </div>
              </div>

              {addStoreProducts && (
                <ImportProducts
                  name="add_store_products"
                  onImport={this.handleImportProducts}
                  loading={importing}
                />
              )}
            </Form.Field>

            <Form.Field className="field-select">
              <Form.Label>Excluir itens na campanha (LMs)</Form.Label>
              <div className="row">
                <div className="col-md-10">
                  <Form.Select
                    isMulti
                    isDisabled={data.extra_data.all_products}
                    placeholder="Excluir itens na campanha (LMs)"
                    noOptionsMessage={() => "Procurar itens"}
                    options={products.data}
                    onInputChange={this.handleFindProduct}
                    onChange={this.handleSelectRemoveProduct}
                    value={data.extra_data.remove_store_products}
                    className="limited-height"
                  />

                  <small className="characters">
                    {data.extra_data.remove_store_products.length}/{MAX_LM_IMPORT_LENGTH} produtos
                  </small>
                </div>

                <div className="col-md-2">
                  <button
                    type="button"
                    className="btn-import-products"
                    onClick={this.handleToggleRemoveStoreProduct}
                    disabled={data.extra_data.all_products}
                  >
                    Importar
                  </button>
                </div>
              </div>

              {removeStoreProducts && (
                <ImportProducts
                  name="remove_store_products"
                  onImport={this.handleImportProducts}
                  loading={importing}
                />
              )}
            </Form.Field>
          </div>
        </div>

        <div className="buttons">
          <Link
            to={{ pathname: "/points/multiplier", filters }}
            className="button-cancel"
          >
            Cancelar
          </Link>

          {edit &&
            Access.hasPermissions("manage-multiplier") &&
            (data.status === "pending" || data.status === "aproved" || data.status === "active") && (
              <Form.Button
                type="button"
                className="button-cancel"
                onClick={this.handleRepprove}
                disabled={saving}
              >
                {repprove.loading ? (
                  <Loading type="btn" size="small" text="Reprovando..." />
                ) : (
                  "Reprovar"
                )}
              </Form.Button>
            )}

          {edit &&
            Access.hasPermissions("manage-multiplier") &&
            data.status === "pending" && (
              <Form.Button
                type="button"
                className="button-save margin-right-15"
                onClick={this.handleApprove}
                disabled={saving}
              >
                {approve.loading ? (
                  <Loading type="btn" size="small" text="Aprovando..." />
                ) : (
                  "Aprovar"
                )}
              </Form.Button>
            )}

          {!edit && (
            <Form.Button
              className="button-save"
              onClick={this.handleSubmit}
              disabled={saving}
            >
              {saving ? (
                <Loading type="btn" size="small" text="Salvando..." />
              ) : (
                "Salvar"
              )}
            </Form.Button>
          )}

          {edit && (
            <Link
              className="button-save"
              to={{
                pathname: `/points/clone`,
                state: { cloneData: data },
              }}
            >
              Clonar
            </Link>
          )}
        </div>
      </Form>
    );
  }
}

const mapState = (state) => ({
  channels: {
    ...state.multipliers.channels,
    data: MultiplierSelectors.channels(state.multipliers.channels.data),
  },
  regions: {
    ...state.multipliers.regions,
    data: MultiplierSelectors.regions(state.multipliers.regions.data),
  },
  stores: {
    ...state.multipliers.stores,
    data: MultiplierSelectors.stores(state.multipliers.stores.data),
  },
  productTypes: {
    ...state.multipliers.productTypes,
    data: MultiplierSelectors.productTypes(state.multipliers.productTypes.data),
  },
  sections: {
    ...state.multipliers.sections,
    data: MultiplierSelectors.sections(state.multipliers.sections.data),
  },
  subSections: {
    ...state.multipliers.subSections,
    data: MultiplierSelectors.subSections(state.multipliers.subSections.data),
  },
  products: {
    ...state.multipliers.products,
    data: MultiplierSelectors.products(state.multipliers.products.data),
  },
  passions: {
    ...state.multipliers.passions,
    data: MultiplierSelectors.passions(state.multipliers.passions.data),
  },
  plans: {
    ...state.multipliers.plans,
    data: MultiplierSelectors.plans(state.multipliers.plans.data),
  },
  approve: state.multipliers.approve,
  repprove: state.multipliers.repprove,
});

const mapActions = (dispatch) =>
  bindActionCreators(MultiplierActions, dispatch);

export default connect(mapState, mapActions)(CustomForm);
